import { render, staticRenderFns } from "./CheckboxImage.vue?vue&type=template&id=616e195c&"
import script from "./CheckboxImage.vue?vue&type=script&lang=js&"
export * from "./CheckboxImage.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxImage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/CheckboxImage.vue
// module id = 406
// module chunks = 0